// extracted by mini-css-extract-plugin
export default {"subtitle":"Page2_subtitle__VQ6+g","btn":"Page2_btn__+i4jI"};